enum MarketingCampaignsRoutes {
  List = '/marketing-campaigns',
}

export default MarketingCampaignsRoutes
